import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/** RFQs belong to Builders. A Yard that lands here is sent home. */
export const Route = createFileRoute("/_app/rfqs")({
  beforeLoad: ({ context }) => {
    if (context.yard.kind !== "builder") throw redirect({ to: "/" });
  },
  component: Outlet,
});
